import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-690c88ea"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "alert alert-error mt-0 mb-8",
  role: "alert",
  "aria-atomic": "true"
}
const _hoisted_2 = { class: "alert-body" }
const _hoisted_3 = { class: "alert-heading" }
const _hoisted_4 = { class: "alert-text nobullet-list" }
const _hoisted_5 = ["id", "onClick"]
const _hoisted_6 = ["id", "href", "onClick"]
const _hoisted_7 = {
  key: 1,
  class: "contact-info"
}
const _hoisted_8 = { style: {"margin-top":"16px"} }
const _hoisted_9 = {
  "aria-label": "kontaktoplysninger",
  class: "table table--borderless table--compact table--responsive-headers d-print-table"
}
const _hoisted_10 = ["id"]
const _hoisted_11 = ["id"]
const _hoisted_12 = {
  key: 0,
  class: "align-text-md-right d-print-none mb-2"
}
const _hoisted_13 = ["id", "onClick"]
const _hoisted_14 = {
  key: 1,
  style: {"min-width":"10%"}
}
const _hoisted_15 = {
  key: 0,
  class: "icon-svg",
  focusable: "false",
  "aria-hidden": "true"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("use", {
  color: "#c00",
  "xlink:href": "#error"
}, null, -1))
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_19 = { class: "no-focus accordion accordion-unbordered accordion-multiselectable" }
const _hoisted_20 = ["aria-controls", "id"]
const _hoisted_21 = { class: "row" }
const _hoisted_22 = {
  class: "col-10",
  style: {"margin-bottom":"16px"}
}
const _hoisted_23 = {
  key: 0,
  class: "col-2 mt-2",
  style: {"text-align":"right"}
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "icon-svg ml-3",
  focusable: "false"
}, [
  /*#__PURE__*/_createElementVNode("use", {
    color: "#000",
    "xlink:href": "#error"
  })
], -1))
const _hoisted_25 = ["id"]
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "mb-6" }, null, -1))
const _hoisted_27 = { class: "row" }
const _hoisted_28 = { class: "col-4 actions" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_30 = { class: "action-div" }
const _hoisted_31 = ["onClick"]
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "icon-svg",
  focusable: "false",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#mode" })
], -1))
const _hoisted_33 = ["onClick", "id"]
const _hoisted_34 = {
  href: "javascript:void(0);",
  class: "function-link"
}
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "icon-svg",
  focusable: "false",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#delete" })
], -1))
const _hoisted_36 = { class: "col-7 summary-details" }
const _hoisted_37 = ["id"]
const _hoisted_38 = {
  "aria-label": "Opsummering af blanket",
  class: "table table--borderless table--compact table--responsive-headers d-print-table"
}
const _hoisted_39 = ["id"]
const _hoisted_40 = ["id"]
const _hoisted_41 = {
  key: 0,
  class: "align-text-md-right d-print-none mb-2"
}
const _hoisted_42 = ["id", "onClick"]
const _hoisted_43 = {
  key: 1,
  style: {"min-width":"10%"}
}
const _hoisted_44 = {
  key: 0,
  class: "icon-svg",
  focusable: "false",
  "aria-hidden": "true"
}
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("use", {
  color: "#c00",
  "xlink:href": "#error"
}, null, -1))
const _hoisted_46 = [
  _hoisted_45
]
const _hoisted_47 = { key: 0 }
const _hoisted_48 = ["id"]
const _hoisted_49 = ["id"]
const _hoisted_50 = {
  key: 0,
  class: "align-text-md-right d-print-none mb-2"
}
const _hoisted_51 = ["id", "onClick"]
const _hoisted_52 = {
  key: 1,
  style: {"min-width":"10%"}
}
const _hoisted_53 = {
  key: 0,
  class: "icon-svg",
  focusable: "false",
  "aria-hidden": "true"
}
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("use", {
  color: "#c00",
  "xlink:href": "#error"
}, null, -1))
const _hoisted_55 = [
  _hoisted_54
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_KlarTekst = _resolveComponent("KlarTekst")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.getProductErrors()?.length > 0 || _ctx.getContactInfoErrors()?.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("p", _hoisted_3, [
              _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.blanket.tg-blanket.produkter.alert.overskrift' }, null, 8, ["tekstNoegle"])
            ]),
            _createElementVNode("ul", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getContactInfoErrors(), (fejl) => {
                return (_openBlock(), _createElementBlock("li", { key: fejl }, [
                  _createElementVNode("a", {
                    class: "function-link",
                    id: 'opsummering-error-' + _ctx.genererDomId(fejl.tcoElementName),
                    href: "javascript:void(0)",
                    onClick: ($event: any) => (_ctx.redigerFeltByTCOElementName(fejl.tcoElementName, 0))
                  }, _toDisplayString(fejl.fejlbesked), 9, _hoisted_5)
                ]))
              }), 128)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.formular.products, (p, index) => {
                return (_openBlock(), _createElementBlock("li", { key: p }, [
                  (_ctx.doContainError(p.formular))
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        class: "function-link",
                        id: 'product-link-'+index,
                        href: '#' + 'product-button-'+index,
                        onClick: ($event: any) => (_ctx.expandAccordion(index))
                      }, [
                        _createElementVNode("div", null, _toDisplayString(p.formular.trin[1].felter[0].vaerdi ? p.formular.trin[1].felter[0].vaerdi : 'Produkt #' + (index + 1)) + " (" + _toDisplayString(_ctx.getErrorCount(p.formular)) + ") ", 1)
                      ], 8, _hoisted_6))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (this.formular.contactInfo != null)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("h3", _hoisted_8, [
            _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.blanket.tg-blanket.kontaktinfo.overskrift' }, null, 8, ["tekstNoegle"])
          ]),
          _createElementVNode("table", _hoisted_9, [
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formular.contactInfo.felter.filter(f => f.felttype !== _ctx.FeltType.OVERSKRIFT && f.felttype !== _ctx.FeltType.HIDDEN), (felt) => {
                return (_openBlock(), _createElementBlock("tr", { key: felt }, [
                  _createElementVNode("th", {
                    class: "w-percent-md-30",
                    id: 'maerkat_' + _ctx.genererDomId(felt.tcoElementName)
                  }, _toDisplayString(felt.maerkat), 9, _hoisted_10),
                  _createElementVNode("td", {
                    style: {"width":"80%"},
                    id: 'vaerdi_' + _ctx.genererDomId(felt.tcoElementName)
                  }, _toDisplayString(_ctx.lavVistNavn(felt)) + " " + _toDisplayString(_ctx.formatEnhed(felt)), 9, _hoisted_11),
                  (this.editable)
                    ? (_openBlock(), _createElementBlock("td", _hoisted_12, [
                        _createElementVNode("a", {
                          id: 'redigerKnap_' + _ctx.genererDomId(felt.tcoElementName),
                          href: "javascript:void(0)",
                          onClick: ($event: any) => (_ctx.redigerFelt(felt, 0))
                        }, "Rediger", 8, _hoisted_13)
                      ]))
                    : _createCommentVNode("", true),
                  (this.editable)
                    ? (_openBlock(), _createElementBlock("td", _hoisted_14, [
                        (!felt.erValid)
                          ? (_openBlock(), _createElementBlock("svg", _hoisted_15, _hoisted_17))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _hoisted_18,
    _createElementVNode("ul", _hoisted_19, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.formular.products, (p, index) => {
        return (_openBlock(), _createElementBlock("li", { key: p }, [
          _createElementVNode("div", {
            class: "mb-5 product-box",
            style: _normalizeStyle(_ctx.doContainError(p.formular) ? 'border:3px solid #c00;': '')
          }, [
            _createElementVNode("button", {
              "aria-controls": 'product-'+index,
              "aria-expanded": "false",
              class: "no-focus accordion-button product-accordion",
              id: 'product-button-'+index
            }, [
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("h3", null, _toDisplayString(p.formular.trin[1].felter[0].vaerdi ? p.formular.trin[1].felter[0].vaerdi : 'Produkt #' + (index + 1)), 1)
                ]),
                (_ctx.doContainError(p.formular))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                      _createTextVNode(" Fejl (" + _toDisplayString(_ctx.getErrorCount(p.formular)) + ")", 1),
                      _hoisted_24
                    ]))
                  : _createCommentVNode("", true)
              ])
            ], 8, _hoisted_20),
            _createElementVNode("div", {
              id: 'product-'+index,
              "aria-hidden": "true",
              class: "accordion-content product-accordion"
            }, [
              _hoisted_26,
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("h5", null, [
                    _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.blanket.tg-blanket.handlinger' }, null, 8, ["tekstNoegle"])
                  ]),
                  _hoisted_29,
                  _createElementVNode("div", _hoisted_30, [
                    _createElementVNode("a", {
                      onClick: ($event: any) => (_ctx.rediger(index)),
                      href: "javascript:void(0);",
                      class: "function-link"
                    }, [
                      _hoisted_32,
                      _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.blanket.tg-blanket.handlinger.rediger' }, null, 8, ["tekstNoegle"])
                    ], 8, _hoisted_31)
                  ]),
                  (this.formular.products.length > 1)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        onClick: ($event: any) => (_ctx.deleteProduct(index)),
                        class: "action-div",
                        id: 'delete-product-' + index
                      }, [
                        _createElementVNode("a", _hoisted_34, [
                          _hoisted_35,
                          _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.blanket.tg-blanket.handlinger.fjern-produkt' }, null, 8, ["tekstNoegle"])
                        ])
                      ], 8, _hoisted_33))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_36, [
                  _createElementVNode("h2", {
                    class: "mt-405",
                    id: 'product-summary-label-'+index
                  }, [
                    _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.blanket.tg-blanket.opsummering-af-oplysninger' }, null, 8, ["tekstNoegle"])
                  ], 8, _hoisted_37),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(p.formular.trin.slice(1, p.formular.trin.length), (trin) => {
                    return (_openBlock(), _createElementBlock("span", { key: trin }, [
                      _createElementVNode("h3", null, _toDisplayString(trin.overskrift), 1),
                      _createElementVNode("table", _hoisted_38, [
                        _createElementVNode("tbody", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(trin.felter.filter(f => f.felttype !== _ctx.FeltType.OVERSKRIFT && f.felttype !== _ctx.FeltType.HIDDEN), (felt) => {
                            return (_openBlock(), _createElementBlock(_Fragment, { key: felt }, [
                              _createElementVNode("tr", null, [
                                _createElementVNode("th", {
                                  class: "w-percent-md-30",
                                  id: 'maerkat_' + _ctx.genererDomIdWithIndex(felt.tcoElementName, index)
                                }, _toDisplayString(felt.maerkat), 9, _hoisted_39),
                                _createElementVNode("td", {
                                  style: {"width":"80%"},
                                  id: _ctx.genererDomIdWithIndex(felt.tcoElementName, index)
                                }, _toDisplayString(_ctx.lavVistNavn(felt)) + " " + _toDisplayString(felt.enhed), 9, _hoisted_40),
                                (this.editable)
                                  ? (_openBlock(), _createElementBlock("td", _hoisted_41, [
                                      _createElementVNode("a", {
                                        id: 'redigerKnap_' + _ctx.genererDomIdWithIndex(felt.tcoElementName, index),
                                        href: "javascript:void(0)",
                                        onClick: ($event: any) => (_ctx.redigerFelt(felt, trin.trin, index))
                                      }, "Rediger", 8, _hoisted_42)
                                    ]))
                                  : _createCommentVNode("", true),
                                (this.editable)
                                  ? (_openBlock(), _createElementBlock("td", _hoisted_43, [
                                      (!felt.erValid)
                                        ? (_openBlock(), _createElementBlock("svg", _hoisted_44, _hoisted_46))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              (felt.felttype === _ctx.FeltType.RADIO_JA_NEJ_MED_INPUT)
                                ? (_openBlock(), _createElementBlock("tr", _hoisted_47, [
                                    _createElementVNode("th", {
                                      class: "w-percent-md-30",
                                      id: 'maerkat_' + _ctx.genererDomIdWithIndex(_ctx.isJaValgt(felt) ? felt.jaInputTcoElementName : felt.nejInputTcoElementName, index)
                                    }, _toDisplayString(_ctx.isJaValgt(felt) ? felt.jaInputMaerkat : felt.nejInputMaerkat), 9, _hoisted_48),
                                    _createElementVNode("td", {
                                      style: {"width":"80%"},
                                      id: _ctx.genererDomIdWithIndex(_ctx.isJaValgt(felt) ? felt.jaInputTcoElementName : felt.nejInputTcoElementName, index)
                                    }, _toDisplayString(this.formatNumeric(_ctx.isJaValgt(felt) ? felt.jaInputVaerdi : felt.nejInputVaerdi)) + " " + _toDisplayString(_ctx.isJaValgt(felt) ? felt.jaInputEnhed : felt.nejInputEnhed), 9, _hoisted_49),
                                    (this.editable)
                                      ? (_openBlock(), _createElementBlock("td", _hoisted_50, [
                                          _createElementVNode("a", {
                                            id: 'redigerKnap_' + _ctx.genererDomIdWithIndex(_ctx.isJaValgt(felt) ? felt.jaInputTcoElementName : felt.nejInputTcoElementName, index),
                                            href: "javascript:void(0)",
                                            onClick: ($event: any) => (_ctx.redigerFelt(felt, trin.trin, index))
                                          }, "Rediger", 8, _hoisted_51)
                                        ]))
                                      : _createCommentVNode("", true),
                                    (this.editable)
                                      ? (_openBlock(), _createElementBlock("td", _hoisted_52, [
                                          (!felt.erValid)
                                            ? (_openBlock(), _createElementBlock("svg", _hoisted_53, _hoisted_55))
                                            : _createCommentVNode("", true)
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true)
                            ], 64))
                          }), 128))
                        ])
                      ])
                    ]))
                  }), 128))
                ])
              ])
            ], 8, _hoisted_25)
          ], 4)
        ]))
      }), 128))
    ])
  ], 64))
}